// src/components/molecules/ChallengeCreator/TitleDescriptionSection.js

import React from "react";
import { Grid, Typography } from "@mui/material";
import CustomCard from "./CustomCard";
import { useTheme } from "styled-components";

const TitleDescriptionSection = ({
  formData,
  handleChange,
  errors,
  disabled,
}) => {
  const theme = useTheme();

  return (
    <CustomCard title="Title & Description">
      <Grid container spacing={2}>
        {/* Title Field */}
        <Grid item xs={12} sx={{ mb: 4 }}>
          <Typography
            variant="body1"
            component="label"
            htmlFor="title"
            sx={{ fontFamily: "basic-sans", color: "white" }}
          >
            What would you like to title this Challenge
          </Typography>
          <input
            type="text"
            id="title"
            name="title"
            value={formData.title}
            onChange={handleChange}
            disabled={disabled} // Disable the field when the prop is true
            style={{
              width: "100%",
              padding: "10px",
              marginTop: "8px",
              fontFamily: "basic-sans",
              fontWeight: 300,
              backgroundColor: disabled ? "#f0f0f0" : "white", // Change background color when disabled
              borderRadius: "5px",
              border: errors.title
                ? `1px solid ${theme.colors.red}`
                : "1px solid #ccc",
            }}
          />
          {errors.title && (
            <Typography
              variant="body2"
              sx={{ color: theme.colors.red, mt: 1, fontFamily: "basic-sans" }}
            >
              {errors.title}
            </Typography>
          )}
        </Grid>

        {/* Description Field */}
        <Grid item xs={12}>
          <Typography
            variant="body1"
            component="label"
            htmlFor="description"
            sx={{ fontFamily: "basic-sans", color: "white" }}
          >
            Add a short description of your Challenge
          </Typography>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            disabled={disabled} // Disable the field when the prop is true
            rows={4}
            style={{
              width: "100%",
              padding: "10px",
              marginTop: "8px",
              fontFamily: "basic-sans",
              fontWeight: "normal",
              backgroundColor: disabled ? "#f0f0f0" : "white", // Change background color when disabled
              borderRadius: "5px",
              border: errors.description
                ? `1px solid ${theme.colors.red}`
                : "1px solid #ccc",
            }}
          />
          {errors.description && (
            <Typography
              variant="body2"
              sx={{ color: theme.colors.red, mt: 1, fontFamily: "basic-sans" }}
            >
              {errors.description}
            </Typography>
          )}
        </Grid>
      </Grid>
    </CustomCard>
  );
};

export default TitleDescriptionSection;
